import defaultRequest, {errorShow} from 'utils/request'
import _ from 'lodash'
import {dispatch, getState} from 'utils/dva'
import baseModal from '../models/base'

function defaultOnBeforeFetch(newFetchOptions) {
    newFetchOptions.headers = {
        ...newFetchOptions.headers,
        Authorization: `Bearer ${_.get(getState(), `${baseModal.namespace}.accessToken`)}`,
    }

    return newFetchOptions
}

function defaultRequestErrorHandle(error, options) {
    const status = _.get(error, 'response.status')

    if (status === 401) {
        dispatch({
            type: `${baseModal.namespace}/immerRemoveAccessToken`,
        })
    } else {
        errorShow(options, error)
    }
}

export default function request(url, fetchOptions = {}, options = {}) {
    options.onBeforeFetch = options.onBeforeFetch || defaultOnBeforeFetch
    options.requestErrorHandle = options.requestErrorHandle || defaultRequestErrorHandle

    return defaultRequest(url, fetchOptions, options)
}
